"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _utils = require("../utils");
var _ThemeProvider = require("../ThemeProvider");
var _props = require("../utils/props");
var _FullScreenIndicator = _interopRequireDefault(require("./FullScreenIndicator"));
var _OverlayIndicator = _interopRequireDefault(require("./OverlayIndicator"));
var _InlineIndicator = _interopRequireDefault(require("./InlineIndicator"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const labelMapping = {
  top: 'column-reverse',
  bottom: 'column',
  left: 'row-reverse',
  right: 'row'
};

/**
 * `ActivityIndicator` renders a visual loading state.
 * It does not handle positioning or layout of that visual loader.
 */
const ActivityIndicator = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    variant,
    tokens,
    label,
    labelPosition = 'bottom',
    showLabel = true,
    inline = false,
    fullScreen = false,
    overlay = false,
    isStatic = false,
    children,
    fullScreenBackgroundColor
  } = _ref;
  const {
    size,
    dotSize,
    color,
    indicatorBackgroundColor,
    fullScreenOverlayBackground,
    thickness
  } = (0, _ThemeProvider.useThemeTokens)('ActivityIndicator', tokens, variant);
  (0, _utils.useScrollBlocking)([_Platform.default.OS === 'web' && fullScreen]);
  const variantProps = {
    variant,
    dotSize,
    size,
    color,
    indicatorBackgroundColor,
    thickness,
    isStatic
  };
  const visibleLabel = showLabel && !!label;
  const commonProps = {
    ref,
    variantProps,
    label,
    labelPosition,
    labelMapping,
    showLabel: visibleLabel
  };
  switch (true) {
    case fullScreen:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FullScreenIndicator.default, {
        ...commonProps,
        backgroundColor: fullScreenBackgroundColor || fullScreenOverlayBackground
      });
    case overlay:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_OverlayIndicator.default, {
        ...commonProps,
        inline: inline,
        isActive: overlay,
        children: children
      });
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InlineIndicator.default, {
        ...commonProps
      });
  }
});
ActivityIndicator.displayName = 'ActivityIndicator';
ActivityIndicator.propTypes = {
  variant: _props.variantProp.propType,
  tokens: (0, _props.getTokensPropType)('ActivityIndicator'),
  /**
   * A visually hidden accessible label describing the action taking place
   */
  label: _propTypes.default.string,
  /**
   * If true, it should render a static ActivityIndicator
   */
  isStatic: _propTypes.default.bool,
  /**
   * Position of the label relative to ActivityIndicator
   */
  labelPosition: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),
  /**
   * show or hide the label
   */
  showLabel: _propTypes.default.bool,
  /**
   * If true, the ActivityIndicator will be displayed in full screen mode
   */
  fullScreen: _propTypes.default.bool,
  /**
   * If true, the ActivityIndicator will be displayed inline
   */
  inline: _propTypes.default.bool,
  /**
   * If true, the ActivityIndicator will be displayed in overlay mode
   */
  overlay: _propTypes.default.bool,
  /**
   * Children to be rendered inside ActivityIndicator
   */
  children: _propTypes.default.node,
  /**
   * Background color of the full screen overlay
   */
  fullScreenBackgroundColor: _propTypes.default.string
};
var _default = exports.default = ActivityIndicator;